import { VueApp } from 'larasnap';
import App from './MagicLogin.vue';

export default class extends VueApp {
    static registerAs = 'MagicLogin';

    constructor(element) {
        super(element, App);
    }
}
